import React, { useState } from 'react'
import { MdMyLocation } from 'react-icons/md'
import { postLocation } from '../../redux/ApiSlice/LocationSlice';
import { AccountProfile } from '../../redux/ApiSlice/AccountProfileSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { IoMdClose } from "react-icons/io";

export default function LocationDetectModal({ handleClose }) {
    const ProfileDetails = useSelector((state) => state.AccountProfile);
    const { User_profile } = ProfileDetails;

    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const uploadLoacation = async (lat, lng) => {
        try {
            const responce = await dispatch(postLocation({ latitude: lat, longitude: lng }));
            if (responce?.payload?.message) {
                dispatch(AccountProfile());
                setIsLoading(false);
                handleClose(false);
                setTimeout(() => {
                    navigate("/neighborhood")
                }, 1000);

            }
        } catch (error) {
            toast.error("Error fetching address details");
        }
    }

    const handleDetectLocation = () => {
        if (navigator.geolocation) {
            setIsLoading(true);
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const lat = position.coords.latitude;
                    const lng = position.coords.longitude;
                    uploadLoacation(lat, lng);
                },
                (error) => {
                    console.error("Error detecting location: ", error);
                    setIsLoading(false);
                }
            );
        } else {
            alert("Geolocation is not supported by this browser.");
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white dark:bg-gray-800 p-2 px-4 w-[80%] md:w-[20%] rounded-lg shadow-lg" onClick={(e) => e.stopPropagation()}>
                <div className='flex justify-between items-center mb-2'>
                    <h2 className="text-[16px] font-bold">Allow Location</h2>
                    <p className='text-[14px] font-bold text-red-600 cursor-pointer' onClick={() => handleClose(false)}>
                        {/* Close */}
                        <IoMdClose className='text-[22px] text-red-600' />
                    </p>
                </div>

                <div className="mb-3">

                    <p className="text-[12px] text-gray-700 dark:text-gray-300">
                        {User_profile?.full_address === "" ? "In order to join your neighborhood group you must allow location permissions" : "Your current location is already set"}
                    </p>

                    <div className="flex justify-center mt-4 items-center">
                        <button
                            className="bg-[#fff] w-full flex justify-center items-center gap-4 hover:bg-black hover:text-white text-black px-6 py-2  rounded-md font-bold border border-black"
                            type="button"
                            onClick={handleDetectLocation}>
                            {isLoading ? "Finding Location" : "Detect Location"}
                            <MdMyLocation className="text-[13px] text-blue-600" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
